export default __webpack_public_path__ + "static/media/RedLand.fa34a2e9.png";